<template>
<!--  <PageLayout class="propositions-page">-->
<!--    <PageTitle class="page-title">Центр котирування</PageTitle>-->
<!--    <Quotations />-->
<!--  </PageLayout>-->
  <div class="onboarding-page">
    <OnboardingView />
  </div>
</template>

<script>

import OnboardingView from "../../views/onboarding";

export default {
  name: 'OnboardingPage',
  components: {
    OnboardingView
  }
};
</script>
